/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-prototype-builtins */
import {
  AfterViewInit,
  Component,
  computed,
  DestroyRef,
  effect,
  ElementRef,
  PLATFORM_ID,
  Renderer2,
  signal,
  ViewChild,
  DOCUMENT,
  inject,
} from '@angular/core';
import { filter } from 'rxjs';
import { langugaes } from '../../../models/common';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { DialogModule } from 'primeng/dialog';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FormsModule } from '@angular/forms';
import { assets } from '../../../core/constants/assets.const';
import { User } from '../../../models/auth';
import {
  notifications,
  notificationsResponse,
} from '../../../models/notification.model';
import { profileStatus } from '../../../models/profileStatus';
import { AuthService } from '../../../services/auth.service';
import { ConfirmDialogService } from '../../../services/confirm-dialog.service';
import { EncryptionService } from '../../../services/encryption.service';
import { InitialService } from '../../../services/initial.service';
import { MessagingService } from '../../../services/messaging.service';
import { NotificationService } from '../../../services/notification.service';
import { SocketsService } from '../../../services/sockets.service';
import { NgxUiLoaderModule, NgxUiLoaderService } from 'ngx-ui-loader';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { driverMapService } from '../../../services/driverMap.service';
import { RideCompletedComponent } from '../../../modals/ride-completed/ride-completed.component';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { GlobalDialogService } from '../../../services/dialog.service';
import { withLoader } from '../../../core/helpers/loader.operator';
import { TranslatePipe } from '../../../core/pipes/translate.pipe';
import { I18nService } from '../../../services/i18n.service';
import { StarsComponent } from '../stars/stars.component';
import { MalayalamPiperTtsService } from '../../../services/malayalam-piper-tts.service';
import { MalayalamTtsService } from '../../../services/malayalam-tts.service';
import { aiService } from '../../../services/ai.service';
import { VoiceAssistantService } from '../../../services/voice-assistant.service';

@Component({
  selector: 'logibids-user-headers',
  templateUrl: './user-headers.component.html',
  styleUrls: ['./user-headers.component.scss'],
  imports: [
    CommonModule,
    TranslatePipe,
    ConfirmDialogModule,
    OverlayPanelModule,
    InfiniteScrollModule,
    DialogModule,
    InputSwitchModule,
    FormsModule,
    StarsComponent,
    NgxUiLoaderModule,
    RouterModule,
  ],
})
export class UserHeadersComponent implements AfterViewInit {
  dropdown = signal(false);
  language = signal(false);
  privacy = signal(false);
  user = computed(() => this._authService.profileDetails());
  checked = signal<boolean>(true);
  is_reqto_driver = signal<boolean>(false);
  schedule_direct_driver = signal<boolean>(false);
  pendingDisplay = signal<boolean>(false);
  rejectedDisplay = signal<boolean>(false);
  filteredLanguages: langugaes[] = [];
  assetsConst = assets;
  @ViewChild('op1') overlayPanel1!: OverlayPanel;
  @ViewChild('op') overlayPanel!: OverlayPanel;
  @ViewChild('op2') overlayPanel2!: OverlayPanel;
  @ViewChild('op3') overlayPanel3!: OverlayPanel;
  selectedLang = signal<string>('');
  protected size = signal<number>(10);
  protected from = signal<number>(1);
  protected total = signal<number>(0);
  notifications = signal<notifications[]>([]);
  @ViewChild('notificationButton', { read: ElementRef })
  notificationButton!: ElementRef;
  notification = signal<boolean>(false);
  private isBrowser: boolean;
  ref: DynamicDialogRef;
  private _authService = inject(AuthService);
  private confirmationService = inject(ConfirmDialogService);
  private translate = inject(I18nService);
  private _EncryptionService = inject(EncryptionService);
  private _NotificationService = inject(NotificationService);
  private _messagingService = inject(MessagingService);
  private renderer = inject(Renderer2);
  private _InitialService = inject(InitialService);
  private _SocketsService = inject(SocketsService);
  private document = inject(DOCUMENT);
  private platformId = inject(PLATFORM_ID);
  private destroyRef = inject(DestroyRef);
  private ngxLoader = inject(NgxUiLoaderService);
  private _driverMapService = inject(driverMapService);
  public dialogService = inject(GlobalDialogService);
  public translateService = inject(I18nService);
  private _aiService = inject(aiService);
  private readonly voiceAssistant = inject(VoiceAssistantService);
  public route = inject(ActivatedRoute);
  public router = inject(Router);
  private readonly malayalamTts = inject(MalayalamTtsService);
  private readonly malayalamPiperTts = inject(MalayalamPiperTtsService);
  constructor() {
    if (isPlatformBrowser(this.platformId)) {
      const savedLang = this.translateService.getCurrentLang();

      this.setDirection(savedLang);
      this.selectedLang.set(savedLang);

      if (this.malayalamTts.shouldUseServerTts(savedLang)) {
        void this.malayalamTts.warmup();
      } else if (this.malayalamTts.isMalayalamLanguage(savedLang)) {
        void this.malayalamPiperTts.preload();
      }
    }
    effect(() => {
      if (
        this._InitialService.languages() &&
        this._InitialService.languages().length > 0
      ) {
        this.filteredLanguages = this._InitialService.languages();
      }

      if (this.user()) {
        const user = this.user()!;
        this.checked.set(user.active);
        this.is_reqto_driver.set(user.is_reqto_driver);
        this.schedule_direct_driver.set(user.schedule_direct_driver);
        this.notification.set(user.notification);
        this.checkerOfProfileStatus();
      }

      if (this._authService.isAuthenticated()) {
        const currentUser = this.user();
        if (!currentUser || !currentUser.default_region) {
          this.getUser();
        }
      }
    });
    // ✅ Use RxJS stream instead of effect() — avoids infinite loop caused by
    //    the signal retaining its last value and continuously invalidating the graph.
    this._messagingService.message$
      .pipe(
        filter(data => !!data),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(data => {
        if (data?.action === 'refresh') {
          this.from.set(1);
          this.getNotificationsRefresh();
        } else {
          const result = data?.find(
            (item: any) => item.user_id === this.user()?.id
          );

          if (result?.id) {
            this.updateNotification(result.id);
          }
        }
      });
  }

  getFormattedMessage(message: string): string {
    if (this.translateService.getCurrentLang() !== 'ar') {
      return message;
    }

    // Unicode LTR isolate markers
    const LTR_ISOLATE = '\u2066';
    const POP_ISOLATE = '\u2069';

    // Match tokens like #IN23898 — hash followed by alphanumerics
    return message.replace(
      /(#[A-Za-z0-9]+)/g,
      `${LTR_ISOLATE}$1${POP_ISOLATE}`
    );
  }

  getLanguages(): void {
    this._InitialService.getLanguages();
  }

  ngAfterViewInit() {
    if (this._authService.isAuthenticated()) {
      this.getUser();
    }
    this.route.queryParamMap.subscribe(params => {
      const notification = params.get('notification');
      if (notification === 'true') {
        setTimeout(() => {
          this.openOverlay();
          this.removeQueryParam();
        }, 0); // Delay to ensure ViewChild is initialized
      }
    });
  }

  removeQueryParam() {
    this.router.navigate([], {
      queryParams: { notification: null }, // Removes the notification param
      queryParamsHandling: 'merge',
    });
  }

  openOverlay() {
    this.hideOP();
    setTimeout(() => {
      // Ensures ViewChild is properly available
      if (this.overlayPanel && this.notificationButton) {
        const event = new MouseEvent('click', { bubbles: true });
        this.overlayPanel.show(event, this.notificationButton.nativeElement);
      }
    }, 100); // Small delay to ensure ViewChild is initialized
  }

  getNotifications(): void {
    const query = `from=${this.from()}&size=${this.size()}`;
    this._NotificationService
      .getNotifications(query)
      .pipe(
        withLoader(this.ngxLoader, 'notificationLoader'),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((res: notificationsResponse) => {
        const newItems = res.list;
        this.notifications.set([...this.notifications(), ...newItems]);
        this.total.set(res.total);
        this.from.set(this.from() + 1);
      });
  }

  getNotificationsRefresh(): void {
    const query = `from=${this.from()}&size=${this.size()}`;
    this._NotificationService
      .getNotificationsRefresh(query)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res: notificationsResponse) => {
        const newItems = res.list;
        this.notifications.set([]);
        this.notifications.set([...this.notifications(), ...newItems]);
        this.total.set(res.total);
        this.from.set(this.from() + 1);
      });
  }

  handleNotificationClick(event: MouseEvent, op: OverlayPanel): void {
    if (this.checkVerification() === false) {
      op.toggle(event);
      this.from.set(1);
      this.getNotifications();
    } else {
      this.alertConfirm();
    }
  }

  handleLanguageClick(event: MouseEvent, op: OverlayPanel): void {
    if (this.checkVerification() === false) {
      op.toggle(event);
      this.getLanguages();
    } else {
      this.alertConfirm();
    }
  }

  updateNotification(notifiId: number): void {
    this._NotificationService
      .updateNotificationById(notifiId)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.refreshNotifications();
      });
  }

  refreshNotifications(): void {
    this.from.set(1);
    this.notifications.set([]);
    this.getNotifications();
    this.getUser();
  }

  onScrollingFinished(): void {
    if (this.notifications().length >= this.total()) return;
    this.getNotifications();
  }

  btn_routeNotification(
    type: string,
    id: number,
    notifiId: number,
    vehicle_id: number,
    driver_id: string
  ): void {
    this.hideOP();
    switch (type) {
      case 'ENQUIRY': {
        this.router
          .navigateByUrl('/sp-bids', { skipLocationChange: true })
          .then(() => {
            this.router.navigateByUrl('/sp-bids/sp-new-bid/' + id + '/1');
          });
        break;
      }
      case 'TRIP': {
        this.router
          .navigateByUrl('/sp-bids', { skipLocationChange: true })
          .then(() => {
            this.router.navigateByUrl('/sp-bids/tracking/' + id);
          });
        break;
      }
      case 'PROFILE': {
        this.router
          .navigateByUrl('/sp-profile', { skipLocationChange: true })
          .then(() => {
            this.router.navigateByUrl('/sp-profile/profile');
          });
        break;
      }
      case 'VEHICLE': {
        this.router
          .navigateByUrl('/sp-bids', { skipLocationChange: true })
          .then(() => {
            this.router.navigateByUrl('/sp/edit-vehicle?id=' + vehicle_id);
          });
        break;
      }
      case 'SCHEDULE': {
        if (this.user().type === 'DRIVER') {
          this.router
            .navigateByUrl('/sp-bids', { skipLocationChange: true })
            .then(() => {
              this.router.navigate(['/sp/schedule/3']);
            });
        } else {
          this.router
            .navigateByUrl('/sp-bids', { skipLocationChange: true })
            .then(() => {
              this.router.navigate(['/sp/schedule/' + this.user().id + '/3']);
            });
        }
        break;
      }
      case 'TRANSACTION': {
        this.router
          .navigateByUrl('/sp-bids', { skipLocationChange: true })
          .then(() => {
            this.router.navigateByUrl('/sp/earnings');
          });
        break;
      }
    }
    this.updateNotification(notifiId);
  }

  hideOP(): void {
    if (this.overlayPanel1) {
      this.overlayPanel1.hide(); // Hide the overlay panel
    }
    if (this.overlayPanel2) {
      this.overlayPanel2.hide(); // Hide the overlay panel
    }
    if (this.overlayPanel3) {
      this.overlayPanel3.hide(); // Hide the overlay panel
    }
    if (this.overlayPanel) {
      this.overlayPanel.hide(); // Hide the overlay panel
    }
  }

  getUser() {
    this._authService.userProfile().subscribe((user: User) => {
      if (
        user.pending_payment &&
        user.pending_payment !== null &&
        user.pending_payment.is_payment_pending === false &&
        user.pending_payment.is_sp_paid === false
      ) {
        this.rideCompleted();
      }
      this._EncryptionService.encryptLocalStorage(user, 'profile');

      if (
        (user.account_type === '' ||
          user.account_type == null ||
          user.account_type === undefined) &&
        user.service_provider != null
      ) {
        this.confirmationService
          .showExisitngSPConfirmationDialog(
            this.translate.translate('PaymentSetupRequired'),
            this.translate.translate('existingSPBody')
          )
          .then(result => {
            if (result) {
              this.router.navigateByUrl('/sp-profile/profile-docs/0');
            }
          });
      }
    });
  }

  rideCompleted() {
    this.ref = this.dialogService.open(RideCompletedComponent, {
      header: '',
      width: '26vw',
      height: '30vw',
      modal: true,
      closable: false,
      styleClass: 'payment',
      data: { id: this.user().pending_payment.enquiry_id },
    });
  }

  checkerOfProfileStatus = (): void => {
    if (this.user.hasOwnProperty('status')) {
      if (
        this.user().status === profileStatus.Pending &&
        this.user().hasOwnProperty('companyIdPhoto') &&
        this.user().hasOwnProperty('companyLicensePhoto')
      ) {
        this.pendingDisplay.set(true);
      } else if (
        this.user().status === profileStatus.Rejected &&
        this.user().hasOwnProperty('companyIdPhoto') &&
        this.user().hasOwnProperty('companyLicensePhoto')
      ) {
        this.rejectedDisplay.set(true);
      }
    }
  };

  checkVerification(): boolean {
    if (this.user().type === 'DRIVER') {
      return false;
    }

    const status = this.user().service_provider?.status;

    return status !== 2 && status !== 5;
  }

  alertConfirm(): void {
    this.confirmationService
      .showConfirmationLogoutUnverified(
        this.translate.translate(' '),
        this.translate.translate('spUnverified')
      )
      .then(result => {
        if (result && isPlatformBrowser(this.platformId)) {
          this._authService.logout().subscribe(() => {
            this.clearUserSessionAndNavigate();
            this.hideOP();
          });
        }
      });
  }

  toggleSignal(sig: typeof this.dropdown) {
    sig.set(!sig());
    this.hideOP();
  }

  showNav() {
    this.toggleSignal(this.dropdown);
    this.language.set(false);
    this.privacy.set(false);
  }

  showLang() {
    this.toggleSignal(this.language);
    this.dropdown.set(false);
    this.privacy.set(false);
  }

  showPrivacy() {
    this.toggleSignal(this.privacy);
    this.language.set(false);
    this.dropdown.set(false);
  }

  gotoPrivacy() {
    this.router.navigate(['/public/web/PRIVACY_POLICY']);
    this.hideOP();
  }

  gotoAboutUs(): void {
    this.router.navigate(['/public/web/ABOUT_US_SP']);
    this.hideOP();
  }

  routeChat(): void {
    this.router.navigateByUrl('/sp/contact');
    this.hideOP();
  }

  gotoTerms() {
    this.router.navigate(['/public/web/TERMS_CONDITIONS']);
    this.hideOP();
  }

  gotoFaq() {
    this.router.navigate(['/public/faq']);
    this.hideOP();
  }

  gotoContact() {
    this.router.navigate(['/public/contact']);
    this.hideOP();
  }

  gotoContract() {
    this.router.navigate(['/public/web/LEGAL_CONTRACT']);
    this.hideOP();
  }

  gotoComplete(): void {
    this.router.navigate(['/sp-profile/profile']);
    this.hideOP();
  }

  gotoChangePassword() {
    this.router.navigate(['/my-profile/change-password'], {
      queryParams: { phoneNumber: this.user().phone_number },
    });
    this.hideOP();
  }

  private clearUserSessionAndNavigate() {
    this.voiceAssistant.disarm();
    this.dialogService.closeAll();
    this.confirmationService.closeAll();
    this.from.set(1);
    const currLang = localStorage.getItem('language');
    this.notifications.set([]);
    localStorage.clear();
    localStorage.setItem('language', currLang || '');
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this._SocketsService.disconnect();
      this.router.navigateByUrl('/auth/login');
    });
  }

  btn_logOut(): void {
    this.confirmationService
      .showConfirmationDialog(' ', this.translate.translate('SureLogout'))
      .then(result => {
        if (result && isPlatformBrowser(this.platformId)) {
          this._authService.logout().subscribe(() => {
            this.clearUserSessionAndNavigate();
            this.hideOP();
          });
        }
      });
  }

  setLanguage(language: string): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    void this.applyLanguageChange(language);
  }

  private async applyLanguageChange(language: string): Promise<void> {
    const previousLang = localStorage.getItem('language') || 'en';

    if (
      this.malayalamTts.isMalayalamLanguage(previousLang) &&
      !this.malayalamTts.isMalayalamLanguage(language)
    ) {
      this.malayalamTts.dispose();
      this.malayalamPiperTts.stop();
    }

    this.selectedLang.set(language);
    this.translateService.persistLanguage(language);

    await this.translateService.ensureLoaded(language);
    this.setDirection(language);
    this._InitialService.setUpGoogleScript(language);
    this.hideOP();
    this.changeLanguagesUser(language);

    if (this.malayalamTts.shouldUseServerTts(language)) {
      void this.malayalamTts.warmup();
    } else if (this.malayalamTts.isMalayalamLanguage(language)) {
      void this.malayalamPiperTts.preload();
    }
  }

  gotoHelpGuide() {
    this.router.navigate(['/public/helpGuide']);
    this.hideOP();
  }

  changeLanguagesUser(language: string): void {
    const payload = { preferred_language: language } as User;
    this._authService.updateProfile(payload).subscribe({
      next: () => {
        if (isPlatformBrowser(this.platformId)) {
          this.softReload();
        }
      },
      error: () => {
        if (isPlatformBrowser(this.platformId)) {
          this.softReload();
        }
      },
    });
  }

  private softReload() {
    window.location.reload();
  }

  private setDirection(lang: string) {
    if (isPlatformBrowser(this.platformId)) {
      const dir = lang === 'ar' ? 'rtl' : 'ltr';

      // Set the direction and language attributes on <html>
      this.renderer.setAttribute(this.document.documentElement, 'dir', dir);
      this.renderer.setAttribute(this.document.documentElement, 'lang', lang);

      // Optional: Add RTL class to body for additional styling
      if (dir === 'rtl') {
        this.renderer.addClass(this.document.body, 'rtl');
      } else {
        this.renderer.removeClass(this.document.body, 'rtl');
      }
    }
  }

  gotoMyProfile() {
    this.router.navigate(['/my-profile']);
    this.hideOP();
  }

  mySchedule(): void {
    if (this.user().type === 'DRIVER') {
      this.router.navigate(['/sp/schedule/3']);
    } else {
      this.router.navigate(['/sp/schedule/' + this.user().id + '/3']);
    }
    this.hideOP();
  }

  gotoMyPreferences() {
    this.router.navigate(['/sp-profile/profile-docs/1']);
    this.hideOP();
  }

  gotoMyDrivers() {
    this.router.navigate(['/sp/drivers']);
    this.hideOP();
  }

  gotoMyVehicles() {
    this.router.navigate(['/sp/my-vehicles']);
    this.hideOP();
  }

  goToMyWallet() {
    this.router.navigate(['/sp/earnings']);
    this.hideOP();
  }

  gotToMyHome() {
    this.router.navigate(['/driver-home']);
    this._driverMapService.setWidget(true);
    this.hideOP();
  }

  goToPaymentOption() {
    this.router.navigate(['/payment']);
    this.hideOP();
  }

  gotoMyTrips() {
    this.router.navigate(['/sp/my-trips']);
    this.hideOP();
  }

  gotoHome() {
    if (this.user().type == 'DRIVER') {
      this.router.navigate(['/driver-home']);
    } else {
      if (
        this.user().service_provider &&
        this.user().service_provider.status === 2
      ) {
        this.router.navigate(['/sp-bids/sp-auctions']);
      } else {
        this.router.navigate(['/sp-profile/profile']);
      }
    }
    this.hideOP();
  }

  gotoMyRating() {
    this.router.navigate(['/sp/my-ratings']);
    this.hideOP();
  }

  gotoMyEnqueires() {
    this.router.navigate(['/sp-bids/sp-auctions']);
    this.hideOP();
  }

  gotoMyScheduleEnqueires() {
    this.router.navigate(['/sp-bids/sp-auctions-schedule']);
    this.hideOP();
  }

  gotoMyImmedidateEnqueires() {
    this.router.navigate(['/sp-bids/sp-auctions-immedidate']);
    this.hideOP();
  }

  deleteUser() {
    this.hideOP();
    this.router.navigateByUrl('/account-control');
  }

  updateUserField(field: keyof User, value: any) {
    const payload = { [field]: value } as User;
    this._authService
      .updateProfile(payload)
      .pipe(
        withLoader(this.ngxLoader, 'uniqueLoader2'),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((resp: any) => {
        (this.user() as any)[field] = value;
        this._EncryptionService.encryptLocalStorage(resp, 'profile');
      });
  }

  toggleStatus(event) {
    this.updateUserField('active', event.checked);
  }

  toggleDriverStatus(event) {
    this.updateUserField('is_reqto_driver', event.checked);
  }

  toggleDriverBidStatus(event) {
    this.updateUserField('schedule_direct_driver', event.checked);
  }

  notificationOnOff(event) {
    this.updateUserField('notification', event.checked);
  }

  getInfo(item) {
    const cat = item.payload.category;
    const enqId = item.payload.enquiryId;
    const language = localStorage.getItem('language') || 'en';
    if (item.payload.pushType == 8) {
      this.router
        .navigate(['/sp/go-trips'], {
          queryParams: {
            type: item.payload.category,
            id: item.payload.enquiryId,
          },
        })
        .then(() => {
          this.router
            .navigateByUrl('/', { skipLocationChange: true })
            .then(() => {
              this.router.navigate(['/sp/go-trips'], {
                queryParams: {
                  type: item.payload.category,
                  id: item.payload.enquiryId,
                },
              });
            });
        });
    } else {
      if (
        item.payload.category == 'DELIVERY' &&
        this.user().type === 'SERVICE_PROVIDER'
      ) {
        this.router
          .navigate(['/sp-bids/sp-new-delivery'], {
            queryParams: { lang: language, id: enqId, type: cat },
          })
          .then(() => {
            this.router
              .navigateByUrl('/', { skipLocationChange: true })
              .then(() => {
                this.router.navigate(['/sp-bids/sp-new-delivery'], {
                  queryParams: { lang: language, id: enqId, type: cat },
                });
              });
          });
      } else if (this.user().type === 'SERVICE_PROVIDER') {
        this.router
          .navigate(['/sp-bids/sp-new-bid'], {
            queryParams: { id: enqId, type: cat, lang: language, page: 1 },
          })
          .then(() => {
            this.router
              .navigateByUrl('/', { skipLocationChange: true })
              .then(() => {
                this.router.navigate(['/sp-bids/sp-new-bid'], {
                  queryParams: {
                    id: enqId,
                    type: cat,
                    lang: language,
                    page: 1,
                  },
                });
              });
          });
      } else {
        this.router.navigate(['/sp/my-trips']);
      }
    }
  }

  openAI(): void {
    this._aiService.setData(true);
    this.hideOP();
  }
}
